import { defineMessages } from 'react-intl';

export const bannerMessages = defineMessages({
  headerMessage: {
    description: 'header message for the promotional migration modal',
    defaultMessage: 'Limited Time Offer',
    id: 'cy8+ta',
  },
  subheaderMessage: {
    description: 'subheader message for the promotional migration modal',
    defaultMessage: 'New plan, more features, fewer fees. Upgrade to our new {planName} plan at an exclusive {percent} discount today!',
    id: 'hD/35y',
  },
  button: {
    description: 'text for a button that shows user an offer',
    defaultMessage: 'View Offer',
    id: '1/Bx9I',
  },
});

export const modalMessages = defineMessages({
  headerMessage: {
    description: 'header message for the promotional migration modal',
    defaultMessage: 'Upgrade your Plan',
    id: 'zGsJup',
  },
  monthlyCost: {
    description: 'label for the monthly cost item in the migration modal',
    defaultMessage: 'Monthly Cost',
    id: 'ci3paJ',
  },
  shipments: {
    description: 'label for the shipments item in the migration modal',
    defaultMessage: 'Shipments',
    id: 'zzElZG',
  },
  users: {
    description: 'label for the users item in the migration modal',
    defaultMessage: 'Users',
    id: 'FyIX09',
  },
  modalBannerHeader: {
    description: 'header for the promotional banner in the migration modal',
    defaultMessage: 'Limited Time Offer',
    id: 'kco0BD',
  },
  modalBannerSubheader: {
    description: 'subheader for the promotional banner in the migration modal',
    defaultMessage: 'Save {price}/month with this {percent} discount.',
    id: 'v4Kxqt',
  },
  featureListHeader: {
    description: 'feature list in the migration modal',
    defaultMessage: "What you'll get:",
    id: 'ljns6F',
  },
  callToActionMessage: {
    description: 'call to action message in the migration modal',
    defaultMessage: "Upgrade now at a comparable retail price to what you're paying currently.",
    id: 'bkTNbt',
  },
  finePrint: {
    description: 'fine print in the migration modal',
    defaultMessage:
      '*Discount is based on published retail price and only applies to the plan ShipStation recommended above or next plan up (if applicable). Discount does not apply to downgrades. Plans are subject to applicable taxes and may be changed by ShipStation at any time.',
    id: 'Ic3Vta',
  },
  cancelButton: {
    description: 'cancel button for the promotional migration modal',
    defaultMessage: 'Not now',
    id: 'BRYV85',
  },
  upgradeSubscriptionButton: {
    description: 'action button for the promotional migration modal',
    defaultMessage: 'Upgrade Subscription',
    id: '1Tvr26',
  },
  addPaymentMethodButton: {
    description: 'add payment method button for the promotional migration modal',
    defaultMessage: 'Add Payment Method',
    id: 'vO8JaD',
  },
  errorNotificationTitle: {
    description: 'title for the error notification when migration fails',
    defaultMessage: 'Something went wrong',
    id: 'bUsueZ',
  },
  errorNotificationContent: {
    description: 'content for the error notification when migration fails',
    defaultMessage: 'We were unable to change your plan. Please try again later.',
    id: 'OiQzkY',
  },
});

export const emailModalMesssages = defineMessages({
  header: {
    description: 'header for the email handoff modal',
    defaultMessage: "Upgrade to ShipStation's new {planName} plan",
    id: '3IQMmG',
  },
  subheader: {
    description: 'subheader for the email handoff modal',
    defaultMessage:
      "As a valued customer, we are offering you an upgrade to a new plan we've launched — at a significant discount. Here is what's included:",
    id: 'NvnDm2',
  },
  callToAction: {
    description: 'cta message for the email handoff modal',
    defaultMessage: "Upgrade now at a comparable retail price to what you're paying currently",
    id: 'rIk+ax',
  },
  altTextForSVG: {
    description: 'alt text for the email handoff modal',
    defaultMessage:
      'ShipStation logo orbitted by nearly a dozen compelling icons that each represent one of the industry-leading features available in higher-tier ShipStation plans',
    id: 'ktZKuA',
  },
  button: {
    description: 'button for the email handoff modal',
    defaultMessage: 'View Offer',
    id: 'tXeC9M',
  },
});

export const getRewardedModalMessages = defineMessages({
  title: {
    description: 'title for the get rewarded modal',
    defaultMessage: 'Welcome to Your New Plan',
    id: 'ZETvx0',
  },
  header: {
    description: 'header for the get rewarded modal',
    defaultMessage: 'Welcome to {plan} — More Power, Less Work',
    id: 'qH8D/4',
  },
  body: {
    description: 'body for the get rewarded modal',
    defaultMessage:
      'You’ve just unlocked the tools to simplify your shipping and reclaim your time. {plan} adds automation, advanced returns & exchanges, and reporting so you can work smarter, not harder.',
    id: 'GnFLyG',
  },
  imageAlt: {
    description: 'alt text for the get rewarded modal image',
    defaultMessage:
      'ShipStation logo orbited by nearly a dozen compelling icons that each represent one of the industry-leading features available in higher-tier ShipStation plans',
    id: '/rc9Co',
  },
  tourNewFeatures: {
    description: 'opt in button for the get rewarded modal',
    defaultMessage: 'Tour New Features',
    id: '/B9SIC',
  },
});

export const planFeatureMessages = defineMessages({
  defaultMessage: {
    description: 'default message for the plan features, in case a billing plan id does not have specific features listed',
    defaultMessage: 'Access to new features and improvements',
    id: 'IoLgOg',
  },
  standardPlan: {
    defaultMessage:
      '<li>Sophisticated rate shopping automation</li>' +
      '<li>Seamless returns (<b>NEW!</b>) that prioritize exchanges</li>' +
      '<li>Bundles, lot tracking, and inventory sync</li>' +
      '<li>Branded tracking to improve customer experience</li>' +
      '<li>No more added fees to use your carrier rates</li>',
    description: 'Bullet points describing the features available on the Standard plan',
    id: 'Up/Bl7',
  },
  premiumPlan: {
    defaultMessage:
      '<li>End-to-end inventory management (<b>NEW!</b>)</li>' +
      '<li>Streamlined warehouse operations with mobile picking (<b>NEW!</b>)</li>' +
      '<li>Seamless returns (<b>NEW!</b>) that prioritize exchanges</li>' +
      '<li>Advanced reporting and analytics (<b>NEW!</b>)</li>' +
      '<li>No more added fees to use your carrier rates</li>',
    description: 'Bullet points describing the features available on the Premium plan',
    id: 'Z7RGF5',
  },
});
